module.exports = __webpack_public_path__ + "img/custom_bath02.6e365206.jpg";